// The Blender Assets piece on the product form's files section: select2
// picker backed by the asset_attachments JSON feed, plus fetch-based
// attach/detach actions. The piece renders inside the section <form>, so
// nothing here may submit or serialize with it — buttons are type="button",
// selects are nameless, and every action posts via fetch then reloads.
import { displayFlashMessage, csrfToken } from "../../../util/methods"
import { safeRefresh } from "../../../components/live_status"

$(document).on("turbolinks:load", function () {
  var $select = $(".js-asset-attachment-select")
  if (!$select.length) return

  $select.select2({
    placeholder: "Search your assets...",
    width: "100%",
    ajax: {
      url: $select.data("url"),
      dataType: "json",
      delay: 300,
      data: function (params) {
        return { q: params.term }
      },
      processResults: function (data) {
        return {
          results: $.map(data, function (asset) {
            var suffixes = []
            if (asset.status === "pending") suffixes.push("unpublished")
            if (asset.already_attached) suffixes.push("already attached")
            else if (asset.already_via_library)
              suffixes.push("included via library")

            return {
              id: asset.guid,
              text:
                asset.name +
                " — " +
                asset.id_type_label +
                " (" +
                asset.library_name +
                ")" +
                (suffixes.length ? " · " + suffixes.join(", ") : ""),
              disabled: asset.already_attached,
            }
          }),
        }
      },
    },
  })
})

$(document).on("turbolinks:before-cache", function () {
  var $select = $(".js-asset-attachment-select")
  if ($select.length && $select.hasClass("select2-hidden-accessible"))
    $select.select2("destroy")
})

$(document).on("click", ".js-asset-grant-attach-library", function () {
  var select = document.querySelector(".js-library-attachment-select")
  if (!select || !select.value) {
    displayFlashMessage("warning", "Choose a library to attach.")
    return
  }

  grantRequest(this, "POST", this.getAttribute("data-url"), {
    asset_library_guid: select.value,
  })
})

$(document).on("click", ".js-asset-grant-attach-asset", function () {
  var select = document.querySelector(".js-asset-attachment-select")
  if (!select || !select.value) {
    displayFlashMessage("warning", "Search for an asset to attach.")
    return
  }

  grantRequest(this, "POST", this.getAttribute("data-url"), {
    asset_guid: select.value,
  })
})

$(document).on("change", ".js-asset-grant-variant", function () {
  grantRequest(this, "PATCH", this.getAttribute("data-url"), {
    product_variant_id: this.value,
  })
})

$(document).on("click", ".js-asset-grant-detach", function () {
  if (!window.confirm(this.getAttribute("data-confirm"))) return

  grantRequest(this, "DELETE", this.getAttribute("data-url"))
})

// Flash copy comes back in the session (the controller sets it before the
// JSON render), so the reload displays it like any full-form action.
function grantRequest(button, method, url, body) {
  button.disabled = true

  fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: body ? JSON.stringify(body) : undefined,
  })
    .then(function (response) {
      return response.json().then(function (json) {
        return { ok: response.ok, json: json }
      })
    })
    .then(function (result) {
      if (result.ok) {
        button.disabled = false
        safeRefresh("Saved.")
      } else {
        button.disabled = false
        displayFlashMessage(
          "warning",
          result.json.message || "That didn't work — try again."
        )
      }
    })
    .catch(function () {
      button.disabled = false
      displayFlashMessage("danger", "Request failed — try again.")
    })
}
